import React, { FC } from 'react'
import s from './RestaurantSectionKuper.module.sass'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { Text } from '@shared/ui/Typography/Text'
import Link from 'next/link'
import IconKuper from '@icons/kuper/icon-kuper.svg'
import { AdvertBadge } from '@shared/ui/Feedback/AdvertBadge'
import AdvDetailed from '@features/Common/AdvDetailed/AdvDetailed'
import { offset } from '@floating-ui/react'

interface Props {
  data: {
    restName: string
    link: string
    description: string
    token: string
  }
  className?: string
}

const RestaurantSectionKuper: FC<Props> = ({ data, className = '' }) => {
  return (
    <ErrorBoundary>
      <div className={`${s.section} ${className}`}>
        <Link className={s.link} href={data.link}></Link>
        <Text className={s.title} sizes={'S'}>
          Заказать доставку
        </Text>
        <IconKuper className={s.icon} />
        <div className={s.separator}></div>
        <div className={s.advert}>
          <AdvertBadge className={s['advert-badge']} sizes={'42x18'} />
          <AdvDetailed tooltipOptions={{ floatingMiddleware: [offset(3)] }}>
            <AdvDetailed.Button className={s['info-button']} iconChange={false} />
            <AdvDetailed.Tooltip description={data.description} token={data.token} />
          </AdvDetailed>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default RestaurantSectionKuper
